/**********************************************************
Chemical Application Form
**********************************************************/
import { TextInput, NumberInput, DatePicker,AutoComplete,
  RadioButton, SelectField } from '../inputs';
import MowTable from './mowing_table';
import { packageForm, mapEmployeeForAutoComplete,
  onDummyComplete } from '../../cult_utils';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const propTypes = {
  eid: PropTypes.string,
  employees: PropTypes.array,
  fields: PropTypes.array,
  formId: PropTypes.string,
  isEditing: PropTypes.bool
};

class MowingForm extends Component {
  render() {
    return (
      <div>
        <form id={this.props.formId} onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="col s12 m3 l3 xl3">
              <DatePicker id={'mow-date'} label={'Date'} min={'2019-01-01'} max={moment().format('YYYY-MM-DD')} required={true} />
            </div>
            <div className="col s12 m3 l3 xl3">
              <label>Location</label>
              <div className="radio-flex">
                <RadioButton id={'mow-kau'} name={'mow-location'} value={'71'} label={'Kau'} onClick={(e) => this.props.fetchFields(e.target.value)} />
                <RadioButton id={'mow-keaau'} name={'mow-location'} value={'72'} label={'Keaau'} onClick={(e) => this.props.fetchFields(e.target.value)} />
              </div>
            </div>
            <div className="col s12 m4 l3 xl3">
              <AutoComplete id={'mow-employee'} label={'Employee'} data={mapEmployeeForAutoComplete(this.props.employees)} onComplete={onDummyComplete} />
            </div>
            <div className="col s12 m3 l3 xl3">
              <NumberInput id={'mow-round'} label={'Round'} min={'1'} max={'10'} step={'1.0'} defaultValue={1} required={true} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m6 l6 xl6">
              <label>Status</label>
              <div className="radio-flex">
                <RadioButton id={'mow-isCompleteYes'} name={'mow-isComplete'} label={'Complete'} value={'Complete'} />
                <RadioButton id={'mow-isCompleteNo'} name={'mow-isComplete'} label={'Incomplete'} value={'Incomplete'} />
              </div>
            </div>
            <div className="col s12 m6 l6 xl6">
              <TextInput id={'mow-comments'} label={'Comments'} defaultValue={'N/A'} />
            </div>
          </div>
        </form><hr />
        <form id={'mow-used-form'} onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="col s12 m3 l3 xl3">
              <SelectField id={'mowing-field'} label={'Field'} opts={this.props.fields} />
            </div>
            <div className="col s12 m3 l3 xl3">
              <NumberInput id={'mowing-hours'} label={'Hours'} min={"0"} max={"5000"} step={"0.1"} />
            </div>
            <div className="col s12 m3 l3 xl3">
              <NumberInput id={'mowing-acresCompleted'} label={'Acres Completed'} min={"0"} max={"5000"} step={"0.1"} />
            </div>
            <div className="col s12 m3 l3 xl3">
              {
                this.props.isEditing ?
                  <center>
                    <button className="btn btn-large blue chem-add"
                      onClick={() => this.props.editMow({
                        mow: packageForm('mow-used-form'),
                        formId: 'mow-used-form',
                        editingMow: this.props.editingMow,
                        mowAppId: this.props.mowAppId
                      })}>
                      Edit Record
                    </button>
                  </center>
                : <center>
                    <button className="btn btn-large chem-add"
                      onClick={() => this.props.addMow({
                        mow: packageForm('mow-used-form'),
                        formId: 'mow-used-form'
                      })}>
                      Add Record
                    </button>
                  </center>
              }
            </div>
          </div>
        </form>
        { this.props.mowJobs.length > 0 ?
          <div className="row">
            <div className="col s12">
              <MowTable mowJobs={this.props.mowJobs} _edit={this.props.selectMowToEdit} _delete={this.props.deleteMow} />
            </div>
          </div>
          : ''
        }
      </div>
    );
  }
}

MowingForm.propTypes = propTypes;
export default MowingForm;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/mowing/mowing_form.js